// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__vfKRe","burgerOpen":"burgerOpen__PR7IT","burgerClose":"burgerClose__0vJuj","light":"light__bWkQd","dark":"dark__DZyGh"};